import {DropdownSelectData, InputDropdownSelectValue} from "app/Interface/Component/Form"
import {InputDropdownDataObject} from "app/Interface/Component/FormDropdown"
import {InputOnChangeFn} from "app/Interface/Component/FormInput"
import ApiSystemLayoutService from "app/Service/Api/System/ApiSystemLayoutService"
import UserService, {subscribeUser} from "app/Service/ClientUser/UserService"
import SystemLayoutService, {SubscribeSystemLayout} from "app/Service/System/Layout/SystemLayoutService"
import SystemModuleService, {subscribeSystemModule} from "app/Service/System/Module/SystemModuleService"
import WebPathService, {SubWebPathService} from "app/Service/System/WebPathService"
import DropdownNavigation from "app/WebController/Component/Nav/DropdownNavigation"
import Logger from "logger/logger"
import React, {useEffect, useState} from "react"
import {useTranslation} from "react-i18next"

export type LayoutSelectorDropdownObject =
  InputDropdownDataObject
  & {
  private: DropdownSelectData[],
  client: DropdownSelectData[],
  default: DropdownSelectData[]
}

const ModuleLayoutSelector = () => {
  const {t} = useTranslation('System.SystemLayout')

  const {patchLayoutDefault} = ApiSystemLayoutService('ModuleLayoutSelector')

  const {systemLayouts} = SystemLayoutService([
    SubscribeSystemLayout.systemLayouts
  ], 'ModuleLayoutSelector')

  const {modulePath, operation} = WebPathService([
    SubWebPathService.modulePath,
    SubWebPathService.operation,
  ], 'ModuleLayoutSelector')

  const {activeSystemModule} = SystemModuleService([
    subscribeSystemModule.activeSystemModule
  ], 'ModuleLayoutSelector')

  const {chosenLayouts} = UserService([
    subscribeUser.chosenLayouts
  ], 'ModuleLayoutSelector')

  const initState: LayoutSelectorDropdownObject = {
    private: [],
    client: [],
    default: [],
  }

  const [layouts, setLayouts] = useState<LayoutSelectorDropdownObject>(initState)

  useEffect(() => {
    Logger('Element.ModuleLayoutSelector.init')
    return () => {
      Logger('Element.ModuleLayoutSelector.init')
    }
  }, [])

  useEffect(function setLayoutsForSelector() {
    if (undefined === operation) return
    if (undefined === modulePath) return
    if (systemLayouts.length < 1) return
    if (undefined === activeSystemModule) {
      if (Object.keys(layouts).length > 0) {
        setLayouts(initState)
        return
      } else
        return
    }

    const globalTranslationKey = `globalLayoutName.${modulePath}.${operation}`
    const chosenLayout = chosenLayouts.find(cl => cl.module === activeSystemModule.id && cl.crudOperator === operation)
    const moduleLayouts = initState

    systemLayouts.map(layout => {
      if (layout.module !== activeSystemModule.id || layout.crudOperator !== operation)
        return

      if (layout.global) {
        moduleLayouts.default.push({
          id: layout.id,
          name: t(globalTranslationKey),
          active: chosenLayout ? chosenLayout.layout === layout.id : true
        })
      } else if (layout.private) {
        moduleLayouts.private.push({
          id: layout.id,
          name: layout.name,
          active: chosenLayout?.layout === layout.id
        })
      } else {
        moduleLayouts.client.push({
          id: layout.id,
          name: layout.name,
          active: chosenLayout?.layout === layout.id,
        })
      }
    })
    setLayouts(moduleLayouts)

  }, [operation, modulePath, systemLayouts, activeSystemModule, chosenLayouts])

  const switchLayout: InputOnChangeFn<InputDropdownSelectValue> = (option) => {
    const layout = systemLayouts.find(l => l.id === option?.id)
    if (layout)
      patchLayoutDefault(layout).then()
  }

  return Object.keys(layouts.client).length < 1 && Object.keys(layouts.private).length < 1 ? null : (
    <DropdownNavigation
      id={'module-layout'}
      title={t('buttons.switchLayout')}
      options={layouts}
      onChange={switchLayout}
    />
  )
}

export default ModuleLayoutSelector
